import styled from "styled-components";
import colors from "./colors";

const MainBox = styled.div`
  // bottom: 0;
  // width: 25%;
  // min-width: 400px;
  // height: 470px;
  // background: ${colors.colorCoreLGray};
  // position: fixed;
  // border-radius: 9px 9px 0px 0px;
  // box-shadow: 0 2px 4px rgb(15 34 58 / 12%);
  // right: 3%;
  // border: none;
  // white-space: nowrap;
  // display: flex;
  // flex-direction: column;
  bottom: 0;
  position: fixed;
  right: 3%;
    width: 400px;
    background: #FFFFFF;
    // border: 0.5px solid #CCCCCC;
    box-shadow: -7.16279px 7.16279px 21.4884px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    overflow: hidden;

    // transition: transform 0.3s ease-out 0s, opacity 0.3s ease-out 0s;
    // transform: scale(1);

    // transform: scale(1);
    // transition: transform 200ms ease-out;


    // height: auto;
    // transition:height 0.10s ease-out;
    // animation: slide-down 0.5s linear both;

    // @keyframes slide-down {
    //   0% {
    //     visibility: hidden;
    //     height: 0;
    //   }
    
    //   95% {
    //     visibility: visible;
    //     height: 230px;
    //   }
    
    //   /* Set height to 'auto' after animation for spacing showing form-invalid feedback message */
    //   100% {
    //     visibility: visible;
    //     height: auto;
    //   }
    // }

    @media (max-width: 768px) {
      right: 0%;
      top: 0%;
      left: 0%;
      width: auto;
      z-index: 11;
    }
`;

const HeaderBar = styled.div`
  // display: flex;
  // align-items: center;
  // padding: 14px 15px;
  // background: ${colors.colorWhite};
  // border-radius: 9px 9px 0px 0px;

  border-radius: 8px 8px 0 0;
  background: ${props => props.background === 'blue' ?
    'linear-gradient(180deg,#005ee8 0%,#191919 194.91%)' :
    props.background === 'yellow' ? 'linear-gradient(180deg,#ff8202 0%,#cecece 194.91%)' :
      'linear-gradient(180deg, #8A86AF 0%, #45415F 194.91%)'};
  h6 {
    font-size: 14px;
    margin: 0;
  }

  .iconCircle i {
    color: ${colors.colorCoreGreen};
    font-size: 9px;
    margin-right: 9px;
  }
  .iconCircleOffline i {
    color: ${colors.colorCoreRed};
    font-size: 9px;
    margin-right: 9px;
  }

  .logo {
    margin: 0px;
    width: 100%;
    text-transform: uppercase;
  }
  .close {
    color: #9b9b9d;
  }

  @media (max-width: 768px) {
    height: 25%;
  }
`;

const TopBar = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px 10px 10px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding : 25px 15px 20px 15px;
  }

  @media (max-width: 768px) { 
    img {
      width: 25px;
      height: auto;
    }
  }
`;

export const LeftPart = styled.div`

`;

const RightPart = styled.div`
  margin-left: auto;
  margin-right: 0px;

  @media (max-width: 768px) { 
    .dropdown-menu {
      left: -75px !important;
      top: 30px;
    }
    .dropdown-menu a {
      font-size: 18px;
      padding: 5px 20px;
    }
  }
`;

const Items = styled.div`
  margin: 0px;
  padding: 0px;
  display: flex;
  align-items: center;
`;

const Item = styled.div`
  padding: 5px;
  display: inline-flex;
  cursor: pointer;

  button {
    border: none;
    background: transparent;
    font-size: 18px;
    padding: 0;
  }
`;

const BadgeButton = styled.div`
  button {
    background: #fff;
    font-size: 10px;
    padding: 3px 4px 3px 8px;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    text-transform: initial;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 25px;
    line-height: 5px;

    @media (max-width: 768px) { 
      font-size: 14px;
      padding: 5px 10px 5px 12px;
    }
  } 
  span {
    margin-left: 5px;
    font-weight: 600;
    background-color: #084aac;

    @media (max-width: 768px) { 
      font-size: 14px;
    }
  }
`;

const ProfileBar = styled.div`
  display: flex;
  align-items: center;
  padding: 0px 25px 25px 25px;
`;

const Avatar = styled.div`
  // width: 50px;
  // height: 50px;
  // border-radius: 50%;
  display: inline-block;
  // border: 0.25px solid rgba(255, 255, 255, 0.5);
  // filter: drop-shadow(0px 5px 10px rgba(0, 0, 0, 0.15));
  position: relative;
  margin-right: 15px;

  img {
    width: 100%;
    height: 100%;
    display: inline-block;
  }
`;

const AgentName = styled.div`
  color: #fff;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;

  @media (max-width: 768px) { 
    font-size: 28px;
  }
`;

const BodyBox = styled.div`
  background: #fff;
  padding: 30px 25px;
  position: relative;

  &:before {
    background: url(images/widget-sape.svg) top left no-repeat;
    background-size: 100%;
    padding: 20px;
    box-sizing: border-box;
    content: '';
    position: absolute;
    top: -15px;
    left: 0px;
    width: 100%;
  
    @media (max-width: 768px) {
      top: -25px;
    }
  }

  @media (max-width: 768px) {
    height: 75%;
    bottom: 0;
    display: -webkit-box;
    // overflow-y: auto;
  }

  @media (max-width: 768px) { 
    span {
      // width: 100%;
      // display: block;
      // height: 100%;
      // overflow-y: auto;
      // overflow-x: hidden;
    }
  }

  
`;

const OnlineBtn = styled.div`
  text-align: center;
  width: 100%;
  // height: 280px;
  display:flex;
  button {
    background: #E5F8E9;
    display: flex;
    justify-content: center;
    margin: auto;
    border-radius: 89.7436px;
    display: inline-block;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #27B647;
    text-decoration: none;
    padding: 10px 30px;
    border : none;

    @media (max-width: 768px) { 
      font-size: 22px;
      padding: 25px 60px;
    }
  }
`

const CallHandlingBox = styled.div`

  @media (max-width: 768px) { 
    margin-top: 40px;
  }

`

const IconRow = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 15px;
  font-size: 15px;

  &:last-child {
    margin-bottom: 0px;
  }

  .active i {
    background: linear-gradient(270.98deg, #1761B5 2.11%, #1565C0 99.41%);
  }

  .active i svg path {
    fill:#ffffff !important
  }

  // .active {
  //   background: linear-gradient(270.98deg, #1761B5 2.11%, #1565C0 99.41%);
  // }

  @media (max-width: 768px) { 
    margin-bottom: 40px;
  }
`;

const ActionIcons = styled.div`
  display: inline-block;
  width: 33.33%;
  text-align: center;
  vertical-align: middle;

  i{
    background: #F5F5F5;
    border-radius: 50px;
    width: 42px;
    height: 42px;
    line-height: 48px;
    display: inline-block;

    @media (max-width: 768px) { 
      width: 60px;
      height: 60px;
    }
  }

  @media (max-width: 768px) { 
    img {
      width: 60px;
    }
  }

  label {
    display: block;
    font-weight: 400;
    font-size: 12px;
    line-height: 28px;
    color: #616161;

    @media (max-width: 768px) { 
      font-size: 16px;
    }
  }
`;
const ActionIconsTwo = styled.div`
  display: inline-block;
  width: 50.00%;
  text-align: center;
  vertical-align: middle;

  i{
    background: #F5F5F5;
    border-radius: 50px;
    width: 42px;
    height: 42px;
    line-height: 48px;
    display: inline-block;
  }

  label {
    display: block;
    font-weight: 400;
    font-size: 12px;
    line-height: 28px;
    color: #616161;
}
`;

const CallBtn = styled.div`
  display: flex;
  width: 100%;
  align-items: center;

  @media (max-width: 768px) { 
    margin-top: 30px;
  }

  i{
    width: 48px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-radius: 50%;
    display: inline-block;

    @media (max-width: 768px) { 
      width: 60px;
      height: 60px;
      line-height: 60px;
    }
  }

  @media (max-width: 768px) { 
    img {
      width: 35px;
    }
  }

  span {
    display: block;
    padding: 5px 0px;
    color: #9B9B9B;
  }
`;

const Decline = styled.div`
  width: 50%;
  text-align: center;
  i{
    background: #F90041;
  }
  
`;

const Accept = styled.div`
  width: 50%;
  text-align: center;
  i{
    background: #0E71EB;
  }
`;


const KeypadOption = styled.div`
  input {
    background: #F8F8F8;
    border: 1px solid #E3E3E3;
    box-sizing: border-box;
    border-radius: 15px;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    width: 100%;
    padding: 10px 15px;
    margin-bottom: 15px;
    color: #303030;
    height: auto;

    @media (max-width: 768px) {
      font-size: 18px;
      padding: 12px 15px;
      border-radius: 25px;
    }
  }

  @media (max-width: 768px) {
    button img {
      width: 51px !important;
    }
  }

  .rdtPicker {
    bottom: 0;
  }
`;

const TagButtonStyle = styled.div`
  @media (max-width: 768px) {
    button {
      padding: 20px 35px;
      font-size: 18px;
    }
  }
`;

const ToggleArea = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  justify-content: center;
  label {
    margin-left: 10px;
    margin-bottom: 0px;
  }
`;

const Numbers = styled.div`
  display: flex;
  width: 100%;
  h6{
    background: #F5F5F5;
    box-shadow: 0px 1px 0px rgba(0, 0, 0, 0.15);
    border-radius: 50px;
    width: 42px;
    height: 42px;
    margin: 0 auto;
    line-height: 44px;
    display: inline-block;
    font-weight: 700;
    font-size: 22px;
    text-align: center;
    color: #000000;
    cursor: pointer;
  }
  img{
    margin: 0 auto;
    text-align: center;
    cursor: pointer;
  }
`;

const Title = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #212121;
  text-align: center;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 24px;
    margin-top: 30px;
    margin-bottom: 30px;
  }
`;

const TeamDropDown = styled.div`
  margin-bottom: 15px;
  .Select-control {
    background: #F8F8F8;
    border: 1px solid #E3E3E3;
    box-sizing: border-box;
    border-radius: 15px;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    width: 100%;
    color: #303030;
    outline: none;
  }
  .Select.is-focused > .Select-control,
  .Select.is-open > .Select-control {
    border-color: #E3E3E3 !important;
    background: #F8F8F8;
  }

  @media (max-width: 768px) {
    .Select-control {
      height: 50px;
      border-radius: 25px;
    }
  }

`;

const InfoDetails = styled.div`
  height: 200px;
  overflow-y: auto;
  width: 100%;
`;

const Group = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    width: 100%;
    margin-top: 20px;
  }

  button {
    position: absolute;
    top: 0px;
    right: 1px;
    padding-right: 0px;
    padding-top: 1px;
  }

  @media (max-width: 768px) {
    button img {
      width: 51px !important;
    }
  }
`;

const Label = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: left;
  letter-spacing: 0.03em;
  color: #6F6F6F;
`;

const Value = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  text-align: right;
  letter-spacing: 0.03em;
  color: #673AB7;
`;

const Tag = styled.div`
  margin: 5px;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  background: #EEE7F9;
  border-radius: 100px;
  padding: 5px 10px;
  display: inline-block;
  color: #673AB7;
`;

const UserList = styled.div`
  height: 200px;
  overflow-y: auto;
  width: 100%;
  scrollbar-width: 2px;
  padding-right: 5px;

  ::-webkit-scrollbar {
    width: 4px;
  }

  @media (max-width: 768px) {
    height: calc(100vh - 70px);
    // overflow-y: hidden;
  }
`;

const ActiveSign = styled.div`

  .active{
    background: #2CCC1F;
  }

  .busy {
    background: #F90041;
  }

  .offline {
    background: #edecec;
  }
`;

const Sign = styled.div`
  position: absolute;
  top: auto;
  bottom: 0px;
  right: 0px;
  
  border-radius: 50%;
  width: 12px;
  height: 12px;
  border: #fff solid 2px;

`;

const ContactNumber = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.03em;
  color: #A6A6A6;
  display: flex;
`;

const Time = styled.div`
  text-align: right;
  font-weight: 500;
  font-size: 10px;
  line-height: 15px;
  margin-left: auto;
  color: #303030;
`;

const BadgeBlue = styled.div`
  background: #023372;
  mix-blend-mode: normal;
  border-radius: 50px;
  font-weight: 500;
  font-size: 8px;
  line-height: 12px;
  letter-spacing: 0.03em;
  padding: 3px 5px;
  color: #FFFFFF;
  text-align: center;
`

const AddNewCallDiv = styled.div`

  @media (max-width: 768px) {
    margin-top: 30px;
  }

  .active {
    border: #1661B7 solid 2px;
    bottom: 6px;
    right: 4px;
  }

  h4 {
    color: #303030;
    font-weight: 700;
    font-size: 20px;
    line-height: 35px;
    margin-bottom: 0px;

    @media (max-width: 768px) {
      font-size: 22px;
    }
  }

  @media (max-width: 768px) {
    h6 {
      font-size: 20px;
    }
  }

  .number {
    color: #808080;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    opacity: 0.6;
  }
`;

const HeadProfileBar = styled.div`
  text-align: center;
  display: block;
  padding: 0px 0px;
  color: #303030;
  margin-bottom: 15px;

`;

const AvatarDiv = styled.div`
  margin: 0 auto;
  display: inline-block;
  width: 80px;
  height: 80px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    display: inline-block;
  }
`;

const TransferCall = styled.div`
  text-align: center;
  width: 50%;
`;

const MergeCall = styled.div`
  text-align: center;
  width: 50%;
`;

const CancelCall = styled.div`
  text-align: center;
  width: 50%;
`;

const Faq = styled.div`
  // margin: 0px -30px;
  padding: 10px 0px;
  border-bottom: #E8E8E8 solid 1px;
  display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
`;

const FaqItem = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  text-align: left;
  letter-spacing: 0.03em;
  color: #6F6F6F;
`;

const FaqValue = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  text-align: right;
  letter-spacing: 0.03em;
  color: #673AB7;
`;

const FaqContent = styled.div`
`;

const ChatScreen = styled.div`
  margin: -15px -30px 0px -30px;
  width: auto;
  overflow: visible;
  height: auto;
  padding: 0px 30px 10px 30px;
  border-bottom: #E8E8E8 solid 1px;
`;

const ChatMessage = styled.div`
  overflow-y: auto;
  height: 200px;
  margin-bottom: 10px;
  border-bottom: 0px;
  margin: -15px -30px 0px -30px;
  padding: 15px 30px 10px 30px;

  .pad {
    padding: 5px 0px;
  }
`;

const LeftMsg = styled.div`
  background: #EEE7F9;
  border-radius: 20px 20px 20px 0px;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #303030;
  padding: 10px;
  display: inline-block;
  width: auto;
  max-width: 80%;
`;

const RightMsg = styled.div`
  background: #E8F0F9;
  border-radius: 20px 20px 0px 20px;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #303030;
  padding: 10px;
  display: flex;
  width: auto;
  max-width: 80%;
  margin-left: auto;
  margin-right: 0px;
`;

const MsgSend = styled.div`
  input {
    margin-bottom: -30px;
  }
`;

const NoInfo = styled.div`
  width: 100%;
  text-align: center;
  padding: 36px;
  span {
    color: #808080;
    font-weight: 500;
    font-size: 12px;
    line-height: 30px;
    opacity: 0.6;
    display: block;

    @media (max-width: 768px) {
      font-size: 16px;
      margin-bottom: 5px;
      margin-top: 15px;
    }
  }

  h4{
    color: #303030;
    font-weight: 600;
    font-size: 16px;
    line-height: 30px;
    margin: 0px;

    @media (max-width: 768px) {
      font-size: 20px;
    }
  }
`;

const InfoCall = styled.div`
  text-align: center;
  width: 50%;
`;

const RejoinCall = styled.div`
  text-align: center;
  width: 50%;
`;

const ItemsFun = styled.div`
  // margin: 0px -30px;
  padding: 10px 10px;
  display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
`;

const ItemsFunItem = styled.div`
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  text-align: left;
  letter-spacing: 0.03em;
  color: #B4B4B4;
`;

const ItemsFunValue = styled.div`
`;

const BreakItem = styled.div`
  border-bottom: #E8E8E8 solid 1px;
  color: #303030;
  font-size: 15px;
  font-weight: 400;
  padding: 10px 25px;
  cursor: pointer;

  &:hover {
    background: #eef3fa;
  }

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

const BreakBar = styled.div`
  text-align: center;
  display: block;
  padding: 0px 0px;
  margin-bottom: 15px;

  h4 {
    color: #0161ed;
    font-weight: 600;
    font-size: 18px;
    line-height: 30px;
    margin-bottom: 0px;
  }

  h6 {
    color: #303030;
    opacity: 0.5;
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 0px;
    line-height: 25px;
    margin-top: 17px;
  }

  h5 {
    color: #0161ed;
    font-weight: 600;
    font-size: 16px;
    line-height: 30px;
    margin-bottom: 40px;
    margin-top: 2px;
  }
`;

const AvatarBreakDiv = styled.div`
  margin: 0 auto;
  display: inline-block;
  width: 89px;
  height: 89px;
  position: relative;
  background: #F5F5F5;
  line-height: 89px;
  border-radius: 50px;
`;

const DashboardCard = styled.div`
  border: 0.45px solid #CCCCCC;
  background: #F1F1F1;
  box-shadow: 0px 6px 11.25px rgba(0, 0, 0, 0.11);
  border-radius: 15px;
  text-align: center;
  margin: 15px;
  padding: 8px;

  h6 {
    color: #0155D2;
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 0px;
  }

  p {
    color: #808080;
    font-weight: 500;
    font-size: 15px;
    margin-bottom: 0px;
  }
`;

const BgImg = styled.div`
  width: 40px;
  height: 40px;
  background: #c5d8f2;
  border-radius: 50px;
  margin: auto;
  line-height: 40px;
  img {
    display: inline-block;
  }
`;

const TabItemsCallStyle = styled.div`

`;


const CustomTabs = styled.div`

  text-align: -webkit-center;

.customTabs {
  border:none;
    border-radius: 6px;
    // background: #EEEEEE;
    margin: 0;
    // width: fit-content;
}
  .nav-tabs {
    border: none;
    // display: flex;
    // justify-content: space-evenly;
    // border: 1.88938px solid #EDE7F6;
    // border-radius: 6px;
    // background: #EEEEEE;
    display: flex;
    justify-content: center;
    margin-bottom: 18px;
  }

  .nav-tabs>li>a {
    margin: none;
    padding: 10px 25px;
    margin-right: 0px;
    font-weight: 500;
    font-size: 14px;
    border: none;
    color: #A6A6A6;
    background: #EEEEEE;
    border-radius: none !important;
    line-height: normal !important;
  }

  .nav-tabs>li>a:hover, .nav-tabs>li>a:focus {
    border-color: none;
    outline: none;
  }

  .nav-tabs>li:first-child>a {
    border-radius: 6px 0px 0px 6px !important;
  }

  .nav-tabs>li>a {
    border-radius: 0px 0px 0px 0px !important;
  }

  .nav-tabs>li:last-child>a {
    border-radius: 0px 6px 6px 0px !important;
  }

  .nav-tabs>li:first-child.active>a, .nav-tabs>li:first-child.active>a:focus, .nav-tabs>li:first-child.active>a:hover {
    border-radius: 6px 0px 0px 6px;
  }

  .nav-tabs>li:last-child.active>a, .nav-tabs>li:last-child.active>a:focus, .nav-tabs>li:last-child.active>a:hover {
    border-radius: 0px 6px 6px 0px;
  }

  .nav-tabs>li.active>a, .nav-tabs>li.active>a:focus, .nav-tabs>li.active>a:hover {
    background: #0161ED;
    box-shadow: 0px 7.125px 14.25px rgba(2, 51, 114, 0.2);
    border: none;
    margin : 0;
    border-radius: 0px 0px 0px 0px;
    color: #fff;
  }
`;

export {
  MainBox,
  HeaderBar,
  TopBar,
  RightPart,
  Items,
  Item,
  ProfileBar,
  Avatar,
  AgentName,
  BodyBox,
  OnlineBtn,
  CallHandlingBox,
  IconRow,
  ActionIcons,
  CallBtn,
  Decline,
  Accept,
  KeypadOption,
  Numbers,
  Title,
  TeamDropDown,
  InfoDetails,
  Group,
  Label,
  Value,
  Tag,
  UserList,
  ActiveSign,
  Sign,
  ContactNumber,
  Time,
  BadgeBlue,
  AddNewCallDiv,
  HeadProfileBar,
  AvatarDiv,
  TransferCall,
  MergeCall,
  CancelCall,
  Faq,
  FaqItem,
  FaqValue,
  FaqContent,
  ChatScreen,
  ChatMessage,
  LeftMsg,
  RightMsg,
  MsgSend,
  NoInfo,
  InfoCall,
  RejoinCall,
  ItemsFun,
  ItemsFunItem,
  ItemsFunValue,
  BreakItem,
  BreakBar,
  AvatarBreakDiv,
  DashboardCard,
  ActionIconsTwo,
  BgImg,
  TabItemsCallStyle,
  CustomTabs,
  BadgeButton,
  TagButtonStyle,
  ToggleArea
}


// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/styles/dialpadstyle.js